import { useAccess } from '../../services/access';

// Shown on a screen the user may read but not act on, so the reason is
// stated once instead of each button failing on its own.
const ReadOnlyNotice = ({ permission, children }) => {
  const { can } = useAccess();
  if (can(permission)) return null;
  return (
    <div
      role="note"
      className="mb-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-300"
    >
      {children}
    </div>
  );
};

export default ReadOnlyNotice;
